/* NUVA — header / mobile menu
   Accesible por teclado: Escape cierra, el foco vuelve al botón que abrió
   el menú, y el foco queda atrapado dentro del menú mientras está abierto. */
(function () {
  'use strict';

  function initHeader(header) {
    if (header._nuvaInit) return;
    header._nuvaInit = true;

    var openBtn = header.querySelector('[data-nuva-menu-open]');
    var menu = header.querySelector('[data-nuva-mobile-menu]');
    if (!openBtn || !menu) { header._nuvaInit = false; return; }

    var closeEls = menu.querySelectorAll('[data-nuva-menu-close]');
    var lastFocused = null;

    function focusableEls() {
      return menu.querySelectorAll('a[href], button:not([disabled])');
    }

    function open() {
      lastFocused = document.activeElement;
      menu.classList.add('is-open');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var f = focusableEls();
      if (f.length) f[0].focus();
      document.addEventListener('keydown', onKeydown);
    }

    function close() {
      menu.classList.remove('is-open');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKeydown);
      if (lastFocused) lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        close();
        return;
      }
      if (e.key === 'Tab') {
        var f = Array.prototype.slice.call(focusableEls());
        if (!f.length) return;
        var first = f[0];
        var last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }

    openBtn.addEventListener('click', open);
    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });

    // Limpieza si Shopify quita/reemplaza esta sección mientras el
    // menú está abierto: evita dejar un listener de "keydown" colgado
    // en document (apuntando a nodos ya desprendidos) y restaura el
    // scroll del body.
    header._nuvaDestroy = function () {
      if (menu.classList.contains('is-open')) close();
      document.removeEventListener('keydown', onKeydown);
    };
  }

  function destroyHeader(header) {
    if (!header._nuvaInit) return;
    header._nuvaInit = false;
    if (typeof header._nuvaDestroy === 'function') header._nuvaDestroy();
  }

  document.querySelectorAll('[data-nuva-header]').forEach(initHeader);

  // Compatibilidad con el editor de temas: reinicializa el menú móvil
  // cuando Shopify reemplaza el HTML de la sección, y limpia listeners
  // globales cuando la sección se quita/reordena.
  document.addEventListener('shopify:section:load', function (evt) {
    var header = evt.target.querySelector('[data-nuva-header]');
    if (header) initHeader(header);
  });
  document.addEventListener('shopify:section:unload', function (evt) {
    var header = evt.target.querySelector('[data-nuva-header]');
    if (header) destroyHeader(header);
  });
})();
